import {
  CAT_RUNNING_WARMUP_DISTANCE,
  CAT_RUNNING_REVIVE_WARMUP_DISTANCE,
} from '../constants'
import { checkGroundObstacleCollision } from './collision'
import {
  updatePlayerAnimation,
  updatePlayerJump,
  updatePlayerPhysics,
  updateSpeedAndDistance,
} from './update/player'
import {
  updateBackgroundScroll,
  updateObstacles,
} from './update/obstacles'
import { updateChurus } from './update/churus'

const getObstacleWarmupDistance = (world) => {
  if (!world.reviveUsed) {
    return world.startWarmupM ?? CAT_RUNNING_WARMUP_DISTANCE
  }

  return world.reviveDistance + (world.continueWarmupM ?? CAT_RUNNING_REVIVE_WARMUP_DISTANCE)
}

// 서버 상대 리플레이(frames) 재생: 물리/충돌 대신 기록된 y좌표를 시간에 맞춰 재생
const applyFrameReplay = (world, runFrameCount) => {
  const frames = world.frameReplay
  if (!frames || frames.length === 0) return

  const tSec = world.elapsedMs / 1000

  let index = world.frameReplayCursor ?? 0
  while (index < frames.length - 1 && frames[index + 1].t <= tSec) {
    index += 1
  }
  world.frameReplayCursor = index

  const current = frames[index]
  const next = frames[index + 1]
  let y = current.y
  if (next && next.t > current.t) {
    const ratio = Math.min(1, Math.max(0, (tSec - current.t) / (next.t - current.t)))
    y = current.y + (next.y - current.y) * ratio
  }

  world.player.previousY = world.player.y
  world.player.y = y
  if (Number.isFinite(current.a) && runFrameCount > 0) {
    world.player.frameIndex = ((current.a % runFrameCount) + runFrameCount) % runFrameCount
  }

  if (tSec >= world.frameReplayDurationSec) {
    world.status = 'gameover'
  }
}

export const updateWorld = (world, deltaSec, runFrameCount) => {
  if (world.status !== 'running') return

  world.invincibleMs = Math.max(0, world.invincibleMs - deltaSec * 1000)
  world.magnetMs = Math.max(0, world.magnetMs - deltaSec * 1000)
  world.reviveGraceMs = Math.max(0, (world.reviveGraceMs ?? 0) - deltaSec * 1000)

  updateSpeedAndDistance(world, deltaSec)
  updateBackgroundScroll(world, deltaSec)

  if (world.frameReplay) {
    applyFrameReplay(world, runFrameCount)
  } else {
    updatePlayerAnimation(world, runFrameCount)
    updatePlayerPhysics(world, deltaSec)
  }

  updateObstacles(world, deltaSec, getObstacleWarmupDistance(world))
  updateChurus(world, deltaSec)

  if (world.maxRunSec && world.elapsedMs >= world.maxRunSec * 1000) {
    world.status = 'gameover'
    return
  }

  if (
    !world.frameReplay &&
    world.invincibleMs <= 0 &&
    world.reviveGraceMs <= 0 &&
    checkGroundObstacleCollision(world)
  ) {
    world.status = 'gameover'
  }
}

export { updatePlayerJump }
